import {
  FETCH_FILE,
  UPLOAD_FILE,
  FETCH_FILES_BY_USER,
  START_LOADING,
  CREATE_ITEM,
  END_LOADING,
  UPLOAD_MULTIPLE_ATTACHMENTS,
  ERROR_UPLOADING_ATTACHMENTS,
} from "./constants";
import * as api from "../api/index.js";
import { fetchFilesByUser } from "../api/index.js";
import { readFromCache, writeToCache } from "../utils/cache";

export const uploadFile = (form) => async (dispatch) => {
  try {
    // dispatch({ type: START_LOADING })
    const { data } = await api.uploadFile(form);
    // history.push(`/profiles/${data._id}`)
    dispatch({ type: UPLOAD_FILE, payload: data });
    return data;
    // dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error);
  }
};

export const uploadFiles =
  (files, openSnackbar, name = "", description = "", options = {}) =>
  async (dispatch) => {
    console.log("uploading files", files);
    // Default configuration
    const config = {
      maxFileSize: 10 * 1024 * 1024, // 10MB default max file size
      allowedFileTypes: [], // Empty array means all file types are allowed
      maxFiles: 20, // Maximum number of files to upload at once
      ...options,
    };

    try {
      dispatch({ type: START_LOADING });

      // Validate input
      if (
        !files ||
        (Array.isArray(files) && files.length === 0) ||
        (files instanceof FormData && !files.has("files"))
      ) {
        dispatch({ type: END_LOADING });
        console.log("No files selected for upload");
        if (openSnackbar) openSnackbar("No files selected for upload");
        return { success: false, message: "No files selected" };
      }

      let formData;
      let validFiles = [];
      let invalidFiles = [];

      // Handle if files is already a FormData object
      if (files instanceof FormData) {
        formData = files;
        console.log("files is FormData", files);
        // Add metadata if provided and not already in the FormData
        if (options.metadata && !formData.has("metadata")) {
          formData.append("metadata", JSON.stringify(options.metadata));
        }
        formData.append("name", name);
        formData.append("description", description);
      } else {
        console.log("files is array", files);
        // Check if too many files
        if (files.length > config.maxFiles) {
          dispatch({ type: END_LOADING });
          const errorMessage = `Too many files. Maximum ${config.maxFiles} files allowed at once.`;
          if (openSnackbar) openSnackbar(errorMessage);
          return { success: false, message: errorMessage };
        }

        // Validate file types and sizes
        for (const file of files) {
          console.log("file", file);
          // Size validation
          if (file.size > config.maxFileSize) {
            invalidFiles.push({
              name: file.name,
              reason: `File size exceeds the maximum allowed size (${Math.round(
                config.maxFileSize / (1024 * 1024)
              )}MB)`,
            });
            continue;
          }

          // Type validation (if specified)
          if (config.allowedFileTypes.length > 0) {
            const fileExtension = file.name.split(".").pop().toLowerCase();
            if (!config.allowedFileTypes.includes(fileExtension)) {
              invalidFiles.push({
                name: file.name,
                reason: `File type not allowed. Allowed types: ${config.allowedFileTypes.join(
                  ", "
                )}`,
              });
              continue;
            }
          }

          validFiles.push(file);
        }

        // Handle invalid files
        if (invalidFiles.length > 0) {
          console.warn("Invalid files detected:", invalidFiles);

          if (invalidFiles.length === files.length) {
            // All files are invalid
            dispatch({ type: END_LOADING });
            const errorMessage = `All files are invalid. Please check file types and sizes.`;
            if (openSnackbar) openSnackbar(errorMessage);
            return {
              success: false,
              message: errorMessage,
              invalidFiles,
            };
          }

          // Some files are invalid but we'll continue with valid ones
          if (openSnackbar) {
            openSnackbar(
              `${invalidFiles.length} file(s) skipped due to invalid type or size.`
            );
          }
        }

        // If no valid files after validation
        if (validFiles.length === 0) {
          dispatch({ type: END_LOADING });
          return { success: false, message: "No valid files to upload" };
        }

        // Create FormData with valid files
        formData = new FormData();
        validFiles.forEach((file) => {
          formData.append("files", file);
        });

        // Add metadata if provided
        if (options.metadata) {
          formData.append("metadata", JSON.stringify(options.metadata));
        }
        formData.append("name", name);
        formData.append("description", description);
      }

      // Log the FormData contents for debugging
      console.log("Uploading files with FormData:", formData);

      // Explicitly log the files being uploaded
      if (formData.getAll) {
        const filesToUpload = formData.getAll("files");
        console.log(`Uploading ${filesToUpload.length} files:`, filesToUpload);
      }

      // Perform the upload
      const { data } = await api.uploadAttachments(formData);
      console.log("Upload response:", data);

      // Update Redux store
      dispatch({
        type: UPLOAD_MULTIPLE_ATTACHMENTS,
        payload: data,
      });

      // Show success notification
      if (openSnackbar) {
        const successMessage =
          validFiles.length === 1
            ? "File uploaded successfully!"
            : `${validFiles.length} files uploaded successfully!`;
        openSnackbar(successMessage);
      }

      dispatch({ type: END_LOADING });

      // Return success result
      return {
        success: true,
        data,
        uploadedCount: validFiles.length,
        skippedCount: invalidFiles.length,
        invalidFiles: invalidFiles.length > 0 ? invalidFiles : undefined,
      };
    } catch (error) {
      console.error("Error uploading files:", error);

      dispatch({ type: END_LOADING });
      dispatch({
        type: ERROR_UPLOADING_ATTACHMENTS,
        payload: error.message || "Error uploading files",
      });

      // Show error notification
      if (openSnackbar) {
        openSnackbar(error.message || "Error uploading files");
      }

      // Return error result
      return {
        success: false,
        message: error.message || "Error uploading files",
        error,
      };
    }
  };

export const fetchFile = (id) => async (dispatch) => {
  try {
    const { data } = (await readFromCache(id)) || (await api.fetchFileById(id));
    dispatch({ type: FETCH_FILE, payload: id });
    await writeToCache(id, { data });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchFiles = (searchQuery) => async (dispatch) => {
  try {
    const { data } =
      (await readFromCache(searchQuery)) ||
      (await api.fetchFilesByUser(searchQuery));
    dispatch({ type: FETCH_FILES_BY_USER, payload: data });
    await writeToCache(searchQuery, { data: data });
  } catch (error) {
    console.log(error);
  }
};
